import React from 'react';
import { useNavigate } from 'react-router-dom';
import './HomeLeft.css';

import toyota from "./assets/toyota.png";
import honda from "./assets/honda.png";
import nissan from "./assets/nissan.png";
import mazda from "./assets/mazda.png";
import suzuki from "./assets/suzuki.png";
import mitsubishi from "./assets/mitsubishi.png";
import daihatsu from "./assets/daihatsu.png";
import subaru from "./assets/subaru.png";
import hino from "./assets/hino.png";
import bmw from "./assets/bmw.png";
import lexus from "./assets/lexus.png";
import mercedes from "./assets/mercedes.png";
import audi from "./assets/audi.png";

import convertible from "./assets/convertible.png";
import coupe from "./assets/coupe.png";
import crossover from "./assets/crossover.png";
import hatchback from "./assets/hatchback.png";
import hybrid from "./assets/hybrid.png";
import luxury from "./assets/luxury.png";
import minivan from "./assets/minivan.png";
import pickup from "./assets/pickup.png";
import sedan from "./assets/sedan.png";
import sports from "./assets/sports.png";
import station from "./assets/station.png";
import sub from "./assets/sub.png";

import PriceIcon from "./assets/Pricetag.webp";

import petrol from "./assets/Patrol.webp";
import disel from "./assets/disel.webp";
import electric from "./assets/Electric.webp";
import ethanol from "./assets/ethanol.webp";
import hybridbody from "./assets/hybridbody.webp";
import semihybrid from "./assets/semihybrid.webp";

const makers = [
    { name: 'TOYOTA', logo: toyota },
    { name: 'HONDA', logo: honda },
    { name: 'NISSAN', logo: nissan },
    { name: 'MAZDA', logo: mazda },
    { name: 'SUZUKI', logo: suzuki },
    { name: 'MITSUBISHI', logo: mitsubishi },
    { name: 'DAIHATSU', logo: daihatsu },
    { name: 'SUBARU', logo: subaru },
    { name: 'HINO', logo: hino },
    { name: 'BMW', logo: bmw },
    { name: 'LEXUS', logo: lexus },
    { name: 'MERCEDES BENZ', logo: mercedes },
    { name: 'AUDI', logo: audi },
];

const bodytypes = [
    { name: 'CONVERTIBLE', logo: convertible },
    { name: 'COUPE', logo: coupe },
    { name: 'CROSSOVER', logo: crossover },
    { name: 'HATCHBACK', logo: hatchback },
    { name: 'HYBRID', logo: hybrid },
    { name: 'LUXURY', logo: luxury },
    { name: 'MINIVAN', logo: minivan },
    { name: 'PICKUP', logo: pickup },
    { name: 'SEDAN', logo: sedan },
    { name: 'SPORTS', logo: sports },
    { name: 'STATION', logo: station },
    { name: 'SUB', logo: sub },
];

const prices = [
    { name: 'Under $500', logo: PriceIcon },
    { name: '$500 - $1,000', logo: PriceIcon },
    { name: '$1,000 - $1,500', logo: PriceIcon },
    { name: '$1,500 - $2,000', logo: PriceIcon },
    { name: '$2,000 - $2,500', logo: PriceIcon },
    { name: '$2,500 - $4,000', logo: PriceIcon },
    { name: '$4,000 - $5,000', logo: PriceIcon },
    { name: '$5,000 - $6,000', logo: PriceIcon },
    { name: 'Over $6,000', logo: PriceIcon },
];

const categories = [
    { name: 'Petrol', logo: petrol },
    { name: 'Disel', logo: disel },
    { name: 'Electric', logo: electric },
    { name: 'Ethanol-FFV', logo: ethanol },
    { name: 'Hybrid', logo: hybridbody },
    { name: 'Hybrid (Diesel)', logo: hybridbody },
    { name: 'Hybrid (Petrol)', logo: hybridbody },
    { name: 'Semi Hybrid', logo: semihybrid },
];

const HomeLeft = () => {
    const navigate = useNavigate();

    const handleItemClick = (criteria, value) => {
        console.log("Criteria:", criteria, "Value:", value); // Debugging
        navigate(`/search-individual?criteria=${criteria}&value=${value}`);
    };
    
    return (
        <>
            <div className="home-left">
                <div className="header text-white text-center py-2 tilename">
                    <h3>Search By Maker</h3>
                </div>
                <ul className="list-group">
                    {makers.map((maker, index) => (
                        <li key={index} className="d-flex align-items-center" onClick={() => handleItemClick('maker', maker.name)}>
                            <img src={maker.logo} alt={maker.name} className="maker-logo me-3" />
                            <span className='serchtitle'>{maker.name}</span>
                        </li>
                    ))}
                </ul>
                <div className="show-more text-center mt-3">
                    <button className="btn btn-success">Show More</button>
                </div>
            </div>

            <div className="home-left">
                <div className="header text-white text-center py-2 tilename">
                    <h3>Search By Type</h3>
                </div>
                <ul className="list-group">
                    {bodytypes.map((bodytype, index) => (
                        <li key={index} className="d-flex align-items-center" onClick={() => handleItemClick('body_type', bodytype.name)}>
                            <img src={bodytype.logo} alt={bodytype.name} className="maker-logo me-3" />
                            <span className='serchtitle'>{bodytype.name}</span>
                        </li>
                    ))}
                </ul>
                <div className="show-more text-center mt-3">
                    <button className="btn btn-outline-dark">Show More</button>
                </div>
            </div>

            <div className="home-left">
                <div className="header text-white text-center py-2 tilename">
                    <h3>Search By Price</h3>
                </div>
                <ul className="list-group">
                    {prices.map((price, index) => (
                        <li key={index} className="d-flex align-items-center">
                            <img src={price.logo} alt={price.name} className="category-logo me-3" />
                            <span className='serchtitle'>{price.name}</span>
                        </li>
                    ))}
                </ul>
                <div className="show-more text-center mt-3">
                    <button className="btn btn-outline-dark">Show More</button>
                </div>
            </div>

            <div className="home-left">
                <div className="header text-white text-center py-2 tilename">
                    <h3>Search By Category</h3>
                </div>
                <ul className="list-group">
                    {categories.map((categor, index) => (
                        <li key={index} className="d-flex align-items-center">
                            <img src={categor.logo} alt={categor.name} className="category-logo me-3" />
                            <span className='serchtitle'>{categor.name}</span>
                        </li>
                    ))}
                </ul>
                <div className="show-more text-center mt-3">
                    <button className="btn btn-outline-dark">Show More</button>
                </div>
            </div>
        </>
    );
};

export default HomeLeft;
